import React, {Component} from "react";
import Dialog from "@material-ui/core/Dialog";

export default class UpdateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStateForUpdation: null,
            toStateModalStatusUpdate: null,
            commentModalStatusUpdate: null,
            nachAccountIdModalStatusUpdate: null,
            selectedBzIdModalStatusUpdate: null,
        }
    }

    getStatusList() {
        if (this.props.creditLineStatusSet) {
            return this.props.creditLineStatusSet.map((st, index) => {
                if (st === this.props.status)
                    return null;
                return <option key={index}>{st}</option>;
            });
        }
    }

    statusSelector() {
        if (!this.props.creditLineStatusSet) {
            return null;
        }
        return (
            <div>
                <select id="status" onChange={this._statusPicker.bind(this)} className="selectpicker"
                        value={this.state.toStateModalStatusUpdate} style={{width: "100%"}}>
                    <option> Status</option>
                    {this.getStatusList()}
                </select>
            </div>
        );
    }

    _statusPicker(event) {
        this.setState({
            toStateModalStatusUpdate: event.target.value
        });
    }

    handleClickUpdate = () => {
        this.props.handleClickUpdate(this.state.nachAccountIdModalStatusUpdate, this.state.toStateModalStatusUpdate, this.state.commentModalStatusUpdate);
    }

    handleChangeRemarkUpdateModal = (event) => {
        this.setState({commentModalStatusUpdate: event.target.value});
    }

    showModalContentForChangeStatus = () => {
        return (
            <div style={{width: '400px', lineHeight: '32px'}}>
                <div className="row" style={{padding: "1em"}}>
                    <div className="col-md-6">
                        Please select new status:
                    </div>
                    <div className="col-md-6">
                        <div className="top-filter" style={{lineHeight: '32px', borderRadius: '4px'}}>
                            {this.statusSelector()}
                        </div>
                    </div>
                </div>
                <div className="row" style={{padding: "1em"}}>
                    <div className="col-md-2">
                        Remark:
                    </div>
                    <div className="col-md-10">
                        <input type="text" name="commentBox" className="updateLineText"
                               placeholder="Comment for status change..." onChange={this.handleChangeRemarkUpdateModal}
                               style={{width: "100%"}}>

                        </input>
                    </div>
                </div>
                <div className="row" style={{padding: "1em"}}>
                    <div className="col-md-4" style={{whiteSpace: 'nowrap'}}>
                        Nach Account ID:
                    </div>
                    <div className="col-md-8">
                        <input type="text" name="NachIdBox" className="updateLineText" placeholder="Nach Account ID"
                               onChange={(event) => this.setState({nachAccountIdModalStatusUpdate: event.target.value})}
                               style={{width: "100%"}}>
                        </input>
                    </div>
                </div>
                <div className="row centralized" style={{alignItems:"center"}}>
                    <div className="centralized col-12" style={{paddingTop: "1em"}}>
                        <button onClick={this.handleClickUpdate} className="btn btn-jt-ops"
                                disabled={!(this.state.commentModalStatusUpdate && (this.state.toStateModalStatusUpdate && this.state.toStateModalStatusUpdate !== "Status")) && !(this.state.nachAccountIdModalStatusUpdate)}>
                            Update
                        </button>
                        <div className="inline">{this.state.loaderForMerging ? this.showCircularLoading() : null}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                <Dialog open={true} onClose={this.props.handleCloseStatusModel}
                        aria-labelledby="responsive-dialog-title" maxWidth="md"
                        classes={{paperWidthSm: "wider-dialoge"}}>
                    <div>
                        <div style={{padding: "15px"}}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="pull-right" onClick={this.props.handleCloseStatusModel}
                                         style={{fontSize: "22px", cursor: "pointer"}}>
                                        <i className="fas fa-times"/>
                                    </div>
                                </div>
                            </div>
                            {this.showModalContentForChangeStatus()}
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/creditLines/components/UpdateModal.js